import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: "#F1A849",
                secondary: "#FFAF6F"
            },
            dark: {
                primary: "#F1A849",
                secondary: "#CA6B1D"
            }
        }
    }
});
